<template>
	<v-row v-if="!loading" class="ma-0 pb-offset">
		<v-col class="pa-0">

			<show v-if="models.complianceasset" :id="id" :models="models" :infos="infos" topClass=""></show>

			<!-- Rischi collegati -->
			<v-card v-if="asset" class="background-2 round-card mt-4">
				<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Rischi collegati</p></v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-0">
					<v-simple-table v-if="asset.risks && asset.risks.length" class="background-2">
						<thead><tr><th>Codice</th><th>Titolo</th><th class="text-right">Punteggio</th></tr></thead>
						<tbody>
							<tr v-for="r in asset.risks" :key="r.id" style="cursor:pointer" @click="$router.push({ name: 'compliancerisks-show', params: { id: r.id } })">
								<td>{{ r.code }}</td>
								<td>{{ r.title }}</td>
								<td class="text-right">{{ r.score != null ? r.score : '–' }}</td>
							</tr>
						</tbody>
					</v-simple-table>
					<div v-else class="pa-4 grey--text text-center">Nessun rischio collegato</div>
				</v-card-text>
			</v-card>

			<!-- Norme -->
			<v-card v-if="asset" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Norme</p>
					<v-spacer></v-spacer>
					<v-btn text color="primary" small @click="openNorms"><v-icon left small>mdi-pencil</v-icon> Modifica</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<template v-if="asset.norms && asset.norms.length">
						<v-chip v-for="n in asset.norms" :key="n.value" :color="n.color || 'primary'" dark small class="mr-1" label>{{ n.text }}</v-chip>
					</template>
					<span v-else class="grey--text">— nessuna —</span>
				</v-card-text>
			</v-card>

			<dms-uploader class="mt-4" :id="id" attachable-type="complianceasset"></dms-uploader>

			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-fab-transition>
						<v-btn v-on="{ ...tooltip }" @click.native="$eventBusUtility.goTo($router, 'complianceassets-edit', id)" color="primary" dark fixed bottom right fab>
							<v-icon>edit</v-icon>
						</v-btn>
					</v-fab-transition>
				</template>
				<span>Modifica</span>
			</v-tooltip>

			<v-dialog v-model="normsDialog" max-width="560" persistent>
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Norme applicabili</p></v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-autocomplete v-model="formNorms" :items="normOptions" item-text="text" item-value="value"
							label="Norme" outlined dense :menu-props="{'offset-y': true}" multiple chips small-chips deletable-chips prepend-icon="mdi-certificate"></v-autocomplete>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-3">
						<v-spacer></v-spacer>
						<v-btn text color="info" @click="normsDialog = false">Annulla</v-btn>
						<v-btn text color="primary" :loading="saving" @click="saveNorms">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'ComplianceAsset',
	props: { id: Number },
	data() {
		return {
			loading: true,
			models: {},
			infos: {},
			normsDialog: false,
			saving: false,
			formNorms: [],
			normOptions: []
		}
	},
	computed: {
		asset() { return this.models.complianceasset }
	},
	created() { this.load() },
	methods: {
		load() {
			this.loading = true
			this.axios.get('complianceassets/' + this.id).then(r => {
				this.models = r.data.models
				this.infos = r.data.infos
				this.loading = false
			}, () => { this.loading = false; this.$store.commit('setSnackbarError') })
		},
		openNorms() {
			this.formNorms = (this.asset.norms || []).map(n => n.value)
			if (!this.normOptions.length) this.axios.get('compliance-norms-options').then(r => { this.normOptions = r.data.data })
			this.normsDialog = true
		},
		saveNorms() {
			this.saving = true
			this.axios.put('complianceassets/' + this.id, { norms: this.formNorms }).then(() => {
				this.saving = false; this.normsDialog = false
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Salvato', timeout: 4000 })
				this.load()
			}, () => { this.saving = false; this.$store.commit('setSnackbarError') })
		}
	}
}
</script>
